import { QueryClientProvider } from '@tanstack/react-query';
import HeaderAgent from './HeaderAgent';
import HeaderBusiness from './HeaderBusiness';
import HeaderLeisure from './HeaderLeisure/HeaderLeisure.container';
import { jsx as _jsx } from "react/jsx-runtime";
export default function Header(_ref) {
  var variant = _ref.variant,
    isIcon = _ref.isIcon,
    queryClient = _ref.queryClient,
    user = _ref.user,
    roles = _ref.roles,
    _ref$bb = _ref.bb,
    bb = _ref$bb === void 0 ? false : _ref$bb,
    useNextImage = _ref.useNextImage;
  return renderHeader(variant);
  function renderHeader(variant) {
    switch (variant) {
      case 'business-step':
      case 'business-default':
        return _jsx(QueryClientProvider, {
          client: queryClient,
          children: _jsx(HeaderBusiness, {
            variant: variant,
            queryClient: queryClient
          })
        });
      case 'default':
      case 'step':
      case 'logo':
        return _jsx(HeaderLeisure, {
          isIcon: isIcon,
          variant: variant,
          queryClient: queryClient,
          bb: bb,
          useNextImage: useNextImage
        });
      case 'agent':
      default:
        return _jsx(HeaderAgent, {
          user: user,
          roles: roles,
          queryClient: queryClient
        });
    }
  }
}